import React from 'react'
import { SuccessPage } from './SuccessEnpalPages/SuccessPage'

export const SuccessEnpalPage = () => {
  return <SuccessPage />
}
